import React from 'react'
import SingleProductView from './SingleProductView'
import "./App.css"
import Footerbottom from '../Search/Footer-bottom'
function Index() {
    return (
        <div>
            <SingleProductView />
            <Footerbottom/> 
        </div>
    )
}

export default Index
